"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var icon_1 = require("../../../constants/img/icon");
var CloseBtn = function (_a) {
    var closeFn = _a.closeFn;
    return ((0, preact_1.h)("button", { class: "preact-btn close-btn" },
        (0, preact_1.h)("img", { src: icon_1.CLOSE_BTN, alt: "X", class: "close-btn__img", onClick: closeFn })));
};
exports.default = CloseBtn;
